import React from "react";
//MUI Imports
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Skeleton from "@mui/material/Skeleton";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

//translations imports
import { useAppLoadingContext } from "../../Context/AppLoadingContext";
import { AppLoadingContextTypes } from "../../Context/ContextTypes/AppLoadingContextTypes";
import DOMPurify from "dompurify";
//converts html code in tags to proper text
import parse from "html-react-parser";
import "./LegalFootnotes.scss";

type LegalFootnotesPropsTypes = {
  legalNotesHeaderText: string;
  legalNotesBodyText: string;
  isInEditor: boolean;
  cqPath: string;
};

export default function LegalFootnotesReact(props: LegalFootnotesPropsTypes) {
  //console.log("<<< LegalFootnotesWrapper >>>>>>>");
  //console.log(props);

  const { translationsData, translationsIsLoading } =
    useAppLoadingContext() as AppLoadingContextTypes;

  const { toggleLegalSection, setToggleLegalSection } =
    useAppLoadingContext() as AppLoadingContextTypes;

  const DomPurify = (tag: string) => {
    return DOMPurify.sanitize(translationsData[tag]);
  };

  const translatedData = {
    legalNotesHeaderText: DomPurify(props.legalNotesHeaderText),
    legalNotesBodyText: parse(DomPurify(props.legalNotesBodyText)),
  };

  return (
    <Box
      component="section"
      id="LegalFootnotesSection"
      className="content-section"
      sx={{
        background: "#e5e5e5",
        marginBottom: "0px !important",
      }}
    >
      {/* component h2 header text */}
      {translationsIsLoading ? (
        <>
          {/* if translations are loading, show Skeleton loading block */}
          <Skeleton animation="wave" height="100px" width="80%" style={{ margin: "0px auto" }} />
        </>
      ) : (
        <Box
          component="div"
          id="LegalFootnotesContainer"
          sx={{
            maxWidth: "1296px",
            margin: "0px auto",
          }}
        >
          <Accordion
            className="accordion-title"
            sx={{
              boxShadow: "none",
              borderBottom: "1px solid #ddd",
              borderRadius: "0 !important",
              background: "inherit",
            }}
            expanded={toggleLegalSection}
            onChange={() => setToggleLegalSection(!toggleLegalSection)}
          >
            <AccordionSummary
              expandIcon={
                !toggleLegalSection ? (
                  <AddIcon sx={{ fontSize: "28px", color: "#000", marginRight: { xs: "15px" } }} />
                ) : (
                  <RemoveIcon
                    sx={{ fontSize: "28px", color: "#000", marginLeft: { xs: "15px" } }}
                  />
                )
              }
              aria-controls={`legalFootNotes`}
              id={`legalFootNotes-header`}
              sx={{
                padding: "0%",
                margin:"5px",
                backgroundColor:"#e5e5e5;",
                "&:focus": {
                  boxShadow: "0 0 0 1px #e5e5e5, 0 0 0 3px #007ffc, 0 0 0px 5px #fff",
                  borderRadius: "2px;",
                  fontWeight: 600,
                },
                "&:focus-visible": {
                  backgroundColor: "inherit",
                },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  padding: { xs: "15px" },
                  fontSize: "18px !important",
                  lineHeight: "28px !important",
                  cursor: "pointer",
                  textAlign:"left",
                  "&:hover": {
                    textDecoration: "underline",
                    textUnderlinePosition: "under",
                  },
                }}
                data-testid="toggleLink"
                onClick={() => setToggleLegalSection(!toggleLegalSection)}
                id="legalFootnote-header"
              >
                {!translatedData.legalNotesHeaderText
                  ? "Header Text i18n tag missing."
                  : translatedData.legalNotesHeaderText}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box
                sx={{
                  padding: { xs: "20px 0", sm: "20px" },
                  width: "90%",
                  margin: "0 auto",
                  fontSize: "18px !important",
                }}
              >
                {!translatedData.legalNotesBodyText
                  ? "Body Text i18n tag missing."
                  : translatedData.legalNotesBodyText}
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      )}
    </Box>
  );
}
